import { mapDTO } from '@twistezo/ts-dto-mapper'

import { WorkspaceProductDTO } from 'features/product/api/types/workspaceProductDTO'
import { WorkspaceProduct } from 'features/product/types/workspaceProduct'

export const workspaceProductFromDTO = (from: WorkspaceProductDTO): WorkspaceProduct =>
  mapDTO<WorkspaceProductDTO, WorkspaceProduct>({ from }).transform(workspaceProductDTO => {
    const { createdAt, from, performanceReportUrl, to, updatedAt, workspace } = workspaceProductDTO

    return {
      ...workspaceProductDTO,
      createdAt: new Date(createdAt),
      from: from ? new Date(from) : undefined,
      performanceReportUrl: performanceReportUrl || undefined,
      to: to ? new Date(to) : undefined,
      updatedAt: new Date(updatedAt),
      workspace: {
        id: workspace.id,
        name: workspace.name,
      },
    }
  })
